// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "static-assets/js/" + "main" + "-legacy." + "f5c5bc07" + ".js"; };